import React, { useState, useEffect } from 'react'
import { json, Link } from 'react-router-dom'
import { saveAs } from 'file-saver';
// import * as XLSX from 'xlsx';
// import XLSX from 'xlsx-style';
import HOLIDAYREPORTDOWNLOAD from './HolidayReportExlComp';
import XlsxPopulate from "xlsx-populate/browser/xlsx-populate";
import { duration } from 'moment';
import { getSkillByDeptID } from '../../HR/Skills/subSkills/api/calls'
import { compareAsc, format } from 'date-fns'
import moment from "moment";
import EmpReportExlComp from './EmpReportExlComp';
import HolidayReportComp from './HolidayReportComp';
import EmpAttendanceReport from './EmpAttendanceReport';
import UserLoginExcelReportComp from './UserLoginExcelReportComp';
import AllEmployeesReports from './AllEmployeesReports';
function UserReportsComp() {
    let SERVER_URL = process.env.REACT_APP_API_URL;
    let BASE_URL = process.env.REACT_APP_APP_URL;
    let token = JSON.parse(localStorage.getItem('key'));

    const [att_report_status, setAtt_report_status] = useState(1);
    const [erremp, setErremp] = useState('');
    const [emp, setEmp] = useState('')
    const [emplist, setEmplist] = useState([])
    const [errcompany, setErrcompany] = useState('')
    const [company, setCompany] = useState('')
    const [comdata, setComdata] = useState([]);
    const [errdepartment, setErrdepartment] = useState('')
    const [department, setDepartment] = useState('');
    const [depdata, setDepdata] = useState([]);
    const [errduration, setEerrduration] = useState('');
    const [duration, setDuration] = useState('');
    const [fromdate, setFromdate] = useState('')
    const [todate, setTodate] = useState('')

    const [todatedivision, setTodatedivision] = useState('')
    const [fromdatedivision, setFromdatedivision] = useState('')


    const [holidaydata, setHolidaydata] = useState([])
    const arr_country = ['', 'India', 'USA', 'UK']
    const [year, setYear] = useState('');
    const [erryear, setErryear] = useState('')
    const [country, setCountry] = useState('');
    const [countrylist, setCountrylist] = useState([]);
    const [errcountry, setErrcountry] = useState('')
    const [report_status, setReport_status] = useState(1);
    const [dept, setDept] = useState([]);
    const [skill, setSkill] = useState('');
    const [reporttype, setReporttype] = useState('')
    const [reportCat, setReportCat] = useState('')

    const HandleReportHoliday = (status) => {
        setReport_status(status)
    }
    useEffect(() => {
        getCountryList()
        getDepartment()
    }, [])
    const getDepartment = async () => {
        const response = await fetch(SERVER_URL + `api/common/department_list`,
            {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'authorization': `bearer ${token.value}`
                },
            }).then(res => res.json())
            .then(data => {
                setDept(data.result)
            })
    }
    const getCountryList = () => {
        const response = fetch(SERVER_URL + `api/common/country_list`,
            {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'authorization': `bearer ${token.value}`
                },
            }).then(res => res.json())
            .then(data => {
                if (data.status == true) {
                    setCountrylist(data.result)
                }
            });
    }


    // DownLoad Exl Report in Year Start Code
    // const HandleClick_Download_HolidayList = () => {
    //     setErrcountry('')
    //     setErryear('')
    //     if (country == '') {
    //         setErrcountry('red');
    //     } else if (year == '') {
    //         setErryear('red')
    //     } else {
    //         downloadHolidayReport()
    //     }
    // }


    // DownLoad Exl Report in Year Start End





    //     const HandleClick_DownloadExc_CustomReport = () => {
    //         if (fromdate == '' || todate == '') {
    //             alert(fromdate);
    //             alert(todate);
    //         } else {

    //             // Fetch employee data
    //             fetch(SERVER_URL + `api/reports/customereport`, {
    //                 method: 'GET',
    //                 headers: {
    //                     'Accept': 'application/json',
    //                     'Content-Type': 'application/json',
    //                     'authorization': `bearer ${token.value}`
    //                 },
    //             }).then(res => res.json())
    //                 .then(data => {
    //                     const newArray = [
    //                         ['Attendance In/Out Details'],
    //                         ['', '', '', ''],
    //                         ['Company Name : Q2a Media services pvt ltd'],
    //                         ['', '', '', ''],
    //                         [`From Date: ${fromdate} To Date: ${todate}`],
    //                         [],
    //                         ['Employee Code', 'Employee Name', 'Company Name', 'Branch Name', 'Department Name', 'Date Of Joining'],
    //                         []
    //                     ];
    //                     if (data?.results?.length > 0) {
    //                         for (var i = 0; i < data?.results.length; i++) {
    //                             let getResult_data = data?.results[i];
    //                             fetch(SERVER_URL + `api/reports/userattendence?userId=${getResult_data.id}&&fromdate=${fromdate}&&todate=${todate}`, {
    //                                 method: 'GET',
    //                                 headers: {
    //                                     'Accept': 'application/json',
    //                                     'Content-Type': 'application/json',
    //                                     'authorization': `bearer ${token.value}`
    //                                 },
    //                             }).then(res => res.json())
    //                                 .then(res_data => {
    //                                     var temp_att = [
    //                                         getResult_data.user_code,
    //                                         getResult_data.name,
    //                                         getResult_data.cmp_name,
    //                                         'Noida',
    //                                         getResult_data.deptName,
    //                                         getResult_data.joining_date
    //                                     ]
    //                                     let startDate = moment(fromdate);
    //                                     let endDate = moment(todate);
    //                                     if (res_data.results.length > 0 && res_data.results.length != '') {
    //                                         for (var m = moment(startDate); m.isSameOrBefore(endDate); m.add(1, 'days')) {

    //                                             const isObjectPresent = res_data.results.find((o) => moment(o.att_date).format('YYYY-MM-DD') == m.format('YYYY-MM-DD'));

    //                                             if (isObjectPresent) {
    //                                                 console.log('if=>', isObjectPresent)
    //                                                 temp_att.push(isObjectPresent.start_time)
    //                                                 temp_att.push(isObjectPresent.end_time)
    //                                                 temp_att.push(isObjectPresent.TOTALDAYSMINUTS)
    //                                                 // temp_att.push(m.format('YYYY-MM-DD'))
    //                                             } else {
    //                                                 console.log('else=>', m.format('YYYY-MM-DD'))
    //                                                 temp_att.push('')
    //                                                 temp_att.push('')
    //                                                 temp_att.push('')
    //                                                 // temp_att.push(m.format('YYYY-MM-DD'))
    //                                             }
    //                                         }
    //                                     } else {
    //                                         for (var m = moment(startDate); m.isSameOrBefore(endDate); m.add(1, 'days')) {
    //                                             temp_att.push('')
    //                                             temp_att.push('')
    //                                             temp_att.push('')
    //                                             // temp_att.push(m.format('YYYY-MM-DD'))
    //                                         }
    //                                     }
    //                                     console.log("temp",temp_att)
    //                                     newArray.push(temp_att)

    //                                 })
    //                         }
    //                         console.log('newArray=>', newArray[8])
    //                         //Generate Excel report
    //                         XlsxPopulate.fromBlankAsync()
    //                             .then((workbook) => {
    //                                 const sheet = workbook.sheet(0);

    // // console.log('newArraynewArraynewArraynewArraynewArray',newArray)
    //                                 newArray.forEach((row, rowIndex) => {
    //                                     console.log('row=>',row)
    //                                     row.forEach((cell, colIndex) => {
    //                                         const cellRef = sheet.cell(rowIndex + 1, colIndex + 1);
    //                                         cellRef.value(cell);



    //                                         if (rowIndex === 0) {
    //                                             cellRef.style({
    //                                                 bold: true,
    //                                                 italic: true,
    //                                                 fontSize: 20,
    //                                                 fill: 'FFFFFF',
    //                                                 horizontalAlignment: 'center',
    //                                             });
    //                                         } else if (rowIndex >= 8) {
    //                                             // console.log('rowIndex :', row[0])
    //                                             //   console.log('rowIndex :', row[0] + moment(row[5]).format("DDMMYYYY"))
    //                                             const colLetterStart = getColumnLetter(colIndex);
    //                                             // sheet.cell(`${colLetterStart}${rowIndex}`).value(`${dayName}, ${formattedDate}`);
    //                                             sheet.cell(`${colLetterStart}${rowIndex}`).value();







    //                                             //  console.log('cell :',cell)
    //                                         } else if (rowIndex === 2 || rowIndex === 4 || rowIndex === 5) {
    //                                             cellRef.style({
    //                                                 bold: true,
    //                                                 italic: true,
    //                                                 fill: 'FFFFFF',
    //                                             });
    //                                         }
    //                                         // else {
    //                                         //     cellRef.style({
    //                                         //         fill: 'FFFFFF',
    //                                         //     });
    //                                         // }
    //                                     });

    //                                 });
    //                                 sheet.range("A1:BS1").merged(true);
    //                                 sheet.range("A2:BS2").merged(true);
    //                                 sheet.range("A3:BS3").merged(true);
    //                                 sheet.range("A4:BS4").merged(true);
    //                                 sheet.range("A5:BS5").merged(true);
    //                                 sheet.range("A6:BS6").merged(true);

    //                                 sheet.column(1).width(22);
    //                                 sheet.column(2).width(20);
    //                                 sheet.column(3).width(30);
    //                                 sheet.column(4).width(22);
    //                                 sheet.column(5).width(22);
    //                                 sheet.column(6).width(22);

    //                                 return workbook.outputAsync();
    //                             })
    //                             .then((blob) => {
    //                                 const url = window.URL.createObjectURL(blob);
    //                                 const anchor = document.createElement('a');
    //                                 anchor.href = url;
    //                                 anchor.download = 'attendance.xlsx';
    //                                 anchor.click();
    //                                 window.URL.revokeObjectURL(url);
    //                             });
    //                     }

    //                 })
    //         }
    //     };

    function convertMinutesToHoursAndMinutes(totalMinutes) {
        const HRS = Math.floor(totalMinutes / 60); // Calculate full hours
        const minutes = totalMinutes % 60; // Remaining minutes
        return `${HRS ? HRS : '00'}:${minutes ? minutes : '00'}`;
    }

    const [workingday, setWorkingday] = useState('')
    var totalBusinessDays = 0;
    function calcBusinessDays(start, end) {
        // This makes no effort to account for holidays
        // Counts end day, does not count start day

        // make copies we can normalize without changing passed in objects    
        var start = new Date(start);
        var end = new Date(end);

        // initial total


        // normalize both start and end to beginning of the day
        start.setHours(0, 0, 0, 0);
        end.setHours(0, 0, 0, 0);

        var current = new Date(start);
        current.setDate(current.getDate() + 1);
        var day;
        // loop through each day, checking
        while (current <= end) {
            day = current.getDay();
            if (day >= 1 && day <= 5) {
                ++totalBusinessDays;
            }
            current.setDate(current.getDate() + 1);
        }
        // console.log(totalBusinessDays)
        setWorkingday(totalBusinessDays)
    }

    // const get_leave_from_date_todate = (startdate, enddate, userId) => {
    //     // console.log(startdate, enddate, userId)
    //     fetch(SERVER_URL + `api/reports/getleave?userId=${userId}&&fromdate=${startdate}&&todate=${enddate}`, {
    //         method: 'GET',
    //         headers: {
    //             'Accept': 'application/json',
    //             'Content-Type': 'application/json',
    //             'authorization': `bearer ${token.value}`
    //         },
    //     }).then(res => res.json())
    //         .then(data => {
    //             console.log(data, '<=data')
    //             return userId
    //         })
    // }

    const HandleClick_DownloadExc_CustomReport = () => {
        if (fromdate == '' || todate == '') {
            alert(fromdate);
            alert(todate);
        } else {

            // console.log('fromdate', fromdate)
            // console.log('todate', todate)
            calcBusinessDays(fromdate, todate)
            // return false

            // Fetch employee data
            fetch(SERVER_URL + `api/reports/customereport?fromdate=${fromdate}&&todate=${todate}`, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'authorization': `bearer ${token.value}`
                },
            }).then(res => res.json())
                .then(data => {
                    // alert(fromdate)
                    // alert(todate)
                    console.log('get leave', data?.results)

                    // return false
                    if (data?.results?.length > 0) {


                        const newArray = [
                            ['Attendance In/Out Details'],
                            ['', '', '', ''],
                            ['Company Name : Q2a Media services pvt ltd'],
                            ['', '', '', ''],
                            [`From Date: ${fromdate} To Date: ${todate}`],
                            [],
                            ['Employee Code', 'Employee Name', 'Company Name', 'Branch Name', 'Department Name', 'Date Of Joining'],
                            ['', '', '', '', '', '']
                        ];


                        let startDate = moment(fromdate);
                        let endDate = moment(todate);
                        const dateHeaders = [];

                        for (let m = moment(startDate); m.isSameOrBefore(endDate); m.add(1, 'days')) {
                            const formattedDate = m.format('YYYY-MM-DD');  // Date in 'YYYY-MM-DD' format
                            const dayOfWeek = m.format('dddd');  // Day of the week (e.g., Monday, Tuesday, etc.)
                            dateHeaders.push(`${dayOfWeek}, ${formattedDate}`);


                        }

                        // console.log('dateHeaders',dateHeaders)

                        newArray[6] = newArray[6].concat(dateHeaders.map(date => [`${date}`, ``, ``]).flat());

                        newArray[7] = newArray[7].concat(dateHeaders.map(date => [`InTime`, `OutTime`, `Total HRS`]).flat());
                        newArray[7] = newArray[7].concat(['Hours completed']);
                        newArray[7] = newArray[7].concat(['Total working days in Month']);
                        newArray[7] = newArray[7].concat(['Working day']);
                        newArray[7] = newArray[7].concat(['Leaves']);
                        newArray[7] = newArray[7].concat(['Hours require']);

                        newArray[7] = newArray[7].concat(['Shortfall hours']);
                        newArray[7] = newArray[7].concat(['Extra hours']);

                        function convertMinutesToHoursAndMinutes(totalMinutes) {
                            const HRS = Math.floor(totalMinutes / 60); // Calculate full hours
                            const minutes = totalMinutes % 60; // Remaining minutes
                            return `${HRS ? HRS : '00'}:${minutes ? minutes : '00'}`;
                        }
                        // Create an array of promises

                        const promises = data.results.map((getResult_data) => {


                            return fetch(SERVER_URL + `api/reports/userattendence?userId=${getResult_data.id}&&fromdate=${fromdate}&&todate=${todate}`, {
                                method: 'GET',
                                headers: {
                                    'Accept': 'application/json',
                                    'Content-Type': 'application/json',
                                    'authorization': `bearer ${token.value}`
                                },
                            }).then(res => res.json())
                                .then(res_data => {
                                    // const leave = get_leave_from_date_todate(fromdate, todate, getResult_data.id)
                                    // console.log(getResult_data.id + '=>' + leave)


                                    const temp_att = [
                                        getResult_data.user_code,
                                        getResult_data.name,
                                        getResult_data.cmp_name,
                                        'Noida',
                                        getResult_data.deptName,
                                        moment(getResult_data.joining_date).format('DD,MMM YYYY')
                                    ];



                                    // console.log('temp_att', res_data.results)
                                    // return false;
                                    // console.log(getResult_data.id)
                                    let startDate = moment(fromdate);
                                    let endDate = moment(todate);

                                    let total_working_hrs = 0
                                    let total_working_days = 0
                                    for (let m = moment(startDate); m.isSameOrBefore(endDate); m.add(1, 'days')) {
                                        const isObjectPresent = res_data.results.find((o) =>
                                            moment(o.att_date).format('YYYY-MM-DD') === m.format('YYYY-MM-DD')
                                        );

                                        if (isObjectPresent) {
                                            temp_att.push(isObjectPresent.start_time);
                                            temp_att.push(isObjectPresent.end_time);
                                            temp_att.push(convertMinutesToHoursAndMinutes(isObjectPresent.TOTALDAYSMINUTS));

                                            // console.log(isObjectPresent.TOTALDAYSMINUTS)
                                            total_working_hrs = total_working_hrs + isObjectPresent.TOTALDAYSMINUTS

                                            total_working_days = total_working_days + 1
                                            // temp_att.push(m.format('YYYY-MM-DD'))
                                        } else {
                                            temp_att.push('');
                                            temp_att.push('');
                                            temp_att.push('');
                                            // temp_att.push(m.format('YYYY-MM-DD'))
                                        }
                                    }
                                    // newArray[8] = newArray[8].concat([total_working_hrs]);

                                    temp_att.push(convertMinutesToHoursAndMinutes(total_working_hrs))
                                    temp_att.push(totalBusinessDays)
                                    temp_att.push(total_working_days)


                                    // get emp leave


                                    // return fetch(SERVER_URL + `api/reports/userattendence?userId=${getResult_data.id}&&fromdate=${fromdate}&&todate=${todate}`, {
                                    //     method: 'GET',
                                    //     headers: {
                                    //         'Accept': 'application/json',
                                    //         'Content-Type': 'application/json',
                                    //         'authorization': `bearer ${token.value}`
                                    //     },
                                    // }).then(res => res.json())
                                    //     .then(res_data => {

                                    //     })


                                    // get emp leave

                                    temp_att.push('')
                                    temp_att.push(total_working_days * 8)
                                    // console.log(temp_att)
                                    //return false




                                    return temp_att;
                                });
                        });

                        // Wait for all promises to complete
                        Promise.all(promises).then((results) => {
                            results.forEach((temp_att) => {
                                newArray.push(temp_att);
                            });

                            // console.log('newArray=>', newArray); // Access after all fetch calls are complete



                            //Generate Excel report
                            XlsxPopulate.fromBlankAsync()
                                .then((workbook) => {
                                    const sheet = workbook.sheet(0);
                                    var setcolumn = 4
                                    var setcolumnRow7 = 1


                                    const mergeCellsInRow = (rowNumber, startColumn, endColumn) => {
                                        if (startColumn < 1 || endColumn < 1) {
                                            console.error("Column numbers must be 1 or greater.");
                                            return;
                                        }
                                        if (startColumn >= endColumn) {
                                            console.error(`Invalid merge range: Start (${startColumn}) must be less than End (${endColumn}).`);
                                            return;
                                        }

                                        const startCell = sheet.cell(rowNumber, startColumn);
                                        const endCell = sheet.cell(rowNumber, endColumn);
                                        const range = sheet.range(startCell, endCell);

                                        try {
                                            range.merged(true); // Merge the range
                                            range.style({
                                                horizontalAlignment: "center", // Center horizontally
                                                verticalAlignment: "center", // Center vertically
                                                bold: true, // Optional: Make text bold
                                                fontSize: 14, // Optional: Set font size
                                            });
                                            // console.log(`Merged cells in row ${rowNumber}, columns ${startColumn}-${endColumn}`);
                                        } catch (error) {
                                            // console.error(`Error merging cells in row ${rowNumber}, columns ${startColumn}-${endColumn}:`, error.message);
                                        }
                                    };

                                    const appendTextToRow = (rowNumber, columnNumber, textToAppend) => {
                                        const cell = sheet.cell(rowNumber, columnNumber);
                                        console.log('cell=>', cell)
                                        // const currentValue = cell.value() || ""; // Get the current value, or empty if not set
                                        cell.value(textToAppend); // Append the new text
                                        // console.log('rowNumber, columnNumber=>', rowNumber, columnNumber)
                                    };


                                    newArray.forEach((row, rowIndex) => {
                                        // console.log(rowIndex, 'row=>', row)

                                        row.forEach((cell, colIndex) => {

                                            // console.log(rowIndex, 'row=>',colIndex, row)
                                            const cellRef = sheet.cell(rowIndex + 1, colIndex + 1);
                                            cellRef.value(cell);



                                            if (rowIndex === 0) {
                                                cellRef.style({
                                                    bold: true,
                                                    italic: true,
                                                    fontSize: 20,
                                                    fill: 'FFFFFF',
                                                    horizontalAlignment: 'center',
                                                });
                                            } else if (rowIndex >= 8) {
                                                // console.log('rowIndex :', row[0])
                                                //   console.log('rowIndex :', row[0] + moment(row[5]).format("DDMMYYYY"))
                                                const colLetterStart = getColumnLetter(colIndex);
                                                // sheet.cell(`${colLetterStart}${rowIndex}`).value(`${dayName}, ${formattedDate}`);
                                                sheet.cell(`${colLetterStart}${rowIndex}`).value();







                                                //  console.log('cell :',cell)
                                            } else if (rowIndex === 2 || rowIndex === 4 || rowIndex === 5) {
                                                cellRef.style({
                                                    bold: true,
                                                    italic: true,
                                                    fill: 'FFFFFF',
                                                });
                                            }
                                            else if (rowIndex == 6) {

                                                // console.log('colIndex=>',colIndex)
                                                sheet.column(setcolumn).width(22);
                                                setcolumn = setcolumn + 3
                                                cellRef.style({
                                                    bold: true,
                                                    // italic: true,
                                                    // fontSize: 10,
                                                    // fill: 'FFFFFF',
                                                    // horizontalAlignment: 'center',
                                                });

                                                mergeCellsInRow(7, setcolumn, setcolumn + 2); // Merge A1:D1
                                            }
                                            // else if (rowIndex == 7) {
                                            //     console.log('setcolumnRow7=>', setcolumnRow7)
                                            //     setcolumnRow7 = setcolumnRow7 + 3
                                            //     appendTextToRow(8, setcolumnRow7, "InTime");
                                            //     // appendTextToRow(8, setcolumnRow7 + 1, "OutTime");
                                            //     // appendTextToRow(8, setcolumnRow7 + 2, "Total HRS");
                                            //     // setcolumnRow7 = setcolumnRow7+3
                                            //     // appendTextToRow(8, setcolumnRow7, "OutTime");
                                            //     // setcolumnRow7 = setcolumnRow7+3
                                            //     // setcolumnRow7 = setcolumnRow7+1
                                            // }

                                            // else if (rowIndex == 6) {
                                            //     mergeCellsInRow(6, 1, 3); // Merge A1:D1
                                            //     mergeCellsInRow(6, 4, 6); // Merge B2:E2
                                            //     mergeCellsInRow(6, 7, 9 ); // Merge A3:C3
                                            // }

                                            // else {
                                            //     cellRef.style({
                                            //         fill: 'FFFFFF',
                                            //     });
                                            // }
                                        });

                                    });



                                    // Merge header ranges
                                    sheet.range("A1:BS1").merged(true);
                                    sheet.range("A2:BS2").merged(true);
                                    sheet.range("A3:BS3").merged(true);
                                    sheet.range("A4:BS4").merged(true);
                                    sheet.range("A5:BS5").merged(true);
                                    sheet.range("A6:BS6").merged(true);

                                    sheet.column(1).width(22);
                                    sheet.column(2).width(20);
                                    sheet.column(3).width(30);
                                    sheet.column(4).width(22);
                                    sheet.column(5).width(22);
                                    sheet.column(6).width(22);
                                    // sheet.column(7).width(202);
                                    // sheet.column(8).width(220);

                                    return workbook.outputAsync();
                                })
                                .then((blob) => {
                                    const url = window.URL.createObjectURL(blob);
                                    const anchor = document.createElement('a');
                                    anchor.href = url;
                                    anchor.download = 'attendance.xlsx';
                                    anchor.click();
                                    window.URL.revokeObjectURL(url);
                                });

                        });
                    }
                });
        }
    };









    // function get_user_attendance(userRecord, fromdate, todate) {

    //     if (userRecord.id == 1 || userRecord.id == 3 || userRecord.id == 2) {
    //         // console.log('fromdate', fromdate)
    //         // console.log('todate', todate)
    //         // console.log('userRecord', userRecord)
    //         fetch(SERVER_URL + `api/reports/userattendence?userId=${userRecord.id}&&fromdate=${fromdate}&&todate=${todate}`, {
    //             method: 'GET',
    //             headers: {
    //                 'Accept': 'application/json',
    //                 'Content-Type': 'application/json',
    //                 'authorization': `bearer ${token.value}`
    //             },
    //         }).then(res => res.json())
    //             .then(res_data => {
    //                 let temp_att = [
    //                     userRecord.user_code,
    //                     userRecord.name,
    //                     userRecord.cmp_name,
    //                     'Noida',
    //                     userRecord.deptName,
    //                     userRecord.joining_date
    //                 ]
    //                 let startDate = moment(fromdate);
    //                 let endDate = moment(todate);
    //                 if (res_data.results.length > 0 && res_data.results.length != '') {
    //                     // console.log(userRecord.id, '=getUserId=', res_data)



    //                     for (var m = moment(startDate); m.isSameOrBefore(endDate); m.add(1, 'days')) {

    //                         // date111.push(m.format('YYYY-MM-DD'));
    //                         // let Obj = {}

    //                         // console.log('date111=',date111)
    //                         // Obj[getUserId]=date111

    //                         // if (m.format('YYYY-MM-DD') == moment(res_data?.results[i]?.att_date).format('YYYY-MM-DD')) {
    //                         //     console.log('if=>', m.format('YYYY-MM-DD'))
    //                         // } else {
    //                         //     console.log(getUserId, 'else=>', m.format('YYYY-MM-DD'))
    //                         // }
    //                         const isObjectPresent = res_data.results.find((o) => moment(o.att_date).format('YYYY-MM-DD') == m.format('YYYY-MM-DD'));
    //                         //  const checkUsername = res_data => res_data;
    //                         //  console.log('checkUsername=>', isObjectPresent.att_date)
    //                         if (isObjectPresent) {
    //                             console.log('if=>', isObjectPresent)
    //                             temp_att.push(isObjectPresent.start_time)
    //                             temp_att.push(isObjectPresent.end_time)
    //                             temp_att.push(isObjectPresent.TOTALDAYSMINUTS)
    //                             temp_att.push(m.format('YYYY-MM-DD'))
    //                         } else {
    //                             console.log('else=>', m.format('YYYY-MM-DD'))
    //                             temp_att.push('')
    //                             temp_att.push('')
    //                             temp_att.push('')
    //                             temp_att.push(m.format('YYYY-MM-DD'))
    //                         }


    //                     }
    //                     // console.log(userRecord.id, '=>', temp_att)
    //                     // return temp_att;

    //                     // const checkUsername = obj => obj.name === 'max';
    //                 } else {
    //                     for (var m = moment(startDate); m.isSameOrBefore(endDate); m.add(1, 'days')) {
    //                         temp_att.push('')
    //                         temp_att.push('')
    //                         temp_att.push('')
    //                         temp_att.push(m.format('YYYY-MM-DD'))
    //                     }

    //                 }
    //                 newArray.push(temp_att);
    //                 console.log('newArray=====>', newArray)

    //             })

    //     }
    // }



    // Helper function to get Excel-like column letters (A, B, Z, AA, AB...)
    const getColumnLetter = (index) => {

        let letter = '';
        while (index >= 0) {
            letter = String.fromCharCode((index % 26) + 65) + letter;
            index = Math.floor(index / 26) - 1;
        }
        //  console.log('index :', index)
        //  console.log('letter :', letter)


        return letter;
    };
    const HandleReportAtt = (status) => {
        setAtt_report_status(status)
    }
    const [deptid, setDeptid] = useState('');
    const [skillsList, setSkillsList] = useState([]);
    function handleChange(deptid) {
        setDeptid(deptid)
        getSkillByDeptID(deptid).then((res) => {
            if (res.status) {
                setSkillsList(res.data);
            }
        })
    }
    const handleChangeGetDept = (skillId) => {
        setSkill(skillId)
        if (deptid != '' && skillId != '') {
            getEmpByDivisionAndDepartment(deptid, skillId)
        }
    }
    const [filteredEmp, setFilteredEmp] = useState([])
    const [empid, setEmpid] = useState('')
    const getEmpByDivisionAndDepartment = async (deptid, skillId) => {
        console.log(deptid, '=>', skillId)

        const response = await fetch(SERVER_URL + `api/employee/getBydivisionAndDepartment?division=${deptid}&department=${skillId}`,
            {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'authorization': `bearer ${token.value}`
                },
            })
            .then(res => res.json())
            .then(res_data => {
                console.log('res_data=>', res_data.results)
                setFilteredEmp(res_data.results)
            })
    }
    // ========================HandleClick_EMP_Report===============================

    const HandleClick_EMP_DIV_Report = () => {
        if (deptid == '') {

        }
        if (fromdatedivision == '') {

        }
        if (todatedivision == '') {

        } else {
            alert(deptid)
            alert(fromdatedivision)
            alert(todatedivision)
        }
    }












    // const HandleClick_EMP_Report = () => {

    //     let start_date = ''
    //     let end_date = ''
    //     if (reporttype != '' && reporttype == 1) {
    //         start_date = moment().startOf('week').format('YYYY-MM-DD');
    //         end_date = moment().endOf('week').format('YYYY-MM-DD');
    //     }
    //     if (reporttype != '' && reporttype == 2) {
    //         start_date = moment().startOf('month').format('YYYY-MM-DD');
    //         end_date = moment().endOf('month').format('YYYY-MM-DD');
    //     }
    //     if (reporttype != '' && reporttype == 3) {
    //         start_date = moment().startOf('year').format('YYYY-MM-DD');
    //         end_date = moment().endOf('year').format('YYYY-MM-DD');
    //     }
    //     if (start_date != '' && end_date != '') {
    //         console.log('startOfMonth', start_date)
    //         console.log('endOfMonth', end_date)
    //         // getEmpAttendance(start_date, end_date)
    //         getUserById()
    //     }


    // }
    // const getUserById = () => {

    //     console.log()
    // }

    // return false


    // const getEmpAttendance = async (start_date, end_date) => {
    //     const response = await fetch(SERVER_URL + `api/reports/getReportBtFilter?fromdate=${start_date}&&todate=${end_date}`,
    //         {
    //             method: 'GET',
    //             headers: {
    //                 'Accept': 'application/json',
    //                 'Content-Type': 'application/json',
    //                 'authorization': `bearer ${token.value}`
    //             },
    //         })
    //         .then(res => res.json())
    //         .then(res_data => {
    //             console.log('res_data=>', 'res_data')
    //             console.log('res_data=>', res_data)
    //             // setFilteredEmp(res_data.results)
    //         })
    // }


    // const [empdivision, setEmpdivision] = useState('')

    return (
        <>
            <div className="page-header">
                <h1>Reports
                    {/* {
                        (hr_permission?.includes('39') && <button href="" className="btn_5 mr10 float-end" onClick={showModal}>Add Holiday</button>)
                    } */}
                </h1>
                <ul id="breadcrumbs" className="breadcrumb mb00">
                    <li>
                        <Link to="/dashboard">Dashboard </Link>
                    </li>
                    <li className="current">
                        <span>/</span> User Reports
                    </li>
                </ul>
            </div>
            <div className="row_bg">
                <div className="row mb30">
                    <div className="col-md-12">
                        <ul className="nav nav-tabs">
                            <li className="nav-item">
                                <button className={`nav-link ${report_status == 1 ? 'active' : ''}`} onClick={() => HandleReportHoliday(1)}>Holiday</button>
                            </li>
                            {/* <li className="nav-item">
                                <button className={`nav-link ${report_status == 2 ? 'active' : ''}`} onClick={() => HandleReportHoliday(2)}>Attendance</button>
                            </li> */}
                            {/* <li className="nav-item">
                                <button className={`nav-link ${report_status == 3 ? 'active' : ''}`} onClick={() => HandleReportHoliday(3)}>Leave</button>
                            </li>
                           
                            
                            */}

                            <li className="nav-item">
                                <button className={`nav-link ${report_status == 2 ? 'active' : ''}`} onClick={() => HandleReportHoliday(2)}>Attendance</button>
                            </li>

                            <li className="nav-item">
                                <button className={`nav-link ${report_status == 3 ? 'active' : ''}`} onClick={() => HandleReportHoliday(3)}>Employee Reports</button>
                            </li>
                            <li className="nav-item">
                                <button className={`nav-link ${report_status == 4 ? 'active' : ''}`} onClick={() => HandleReportHoliday(4)}>Login Reports</button>
                            </li>
                            <li className="nav-item">
                                <button className={`nav-link ${report_status == 5 ? 'active' : ''}`} onClick={() => HandleReportHoliday(5)}>All Employees</button>
                            </li>
                        </ul>
                        <div className="tab-content tab_wrapper">
                            {report_status == 1 && <HolidayReportComp />}
                            {report_status == 2 && <EmpAttendanceReport />}
                            {report_status == 3 && <EmpReportExlComp />}
                            {report_status == 4 && <UserLoginExcelReportComp />}
                            {report_status == 5 && <AllEmployeesReports />}


                            {/* <div className="tab-pane" style={{ display: report_status == 2 ? 'block' : 'none' }}>
                                <div className='row'>
                                    <div className='col-md-3'>
                                        <div className='form-blk mb25'>
                                            <div className='form-label'>Employee Type Reports</div>
                                            <div className='form-input'>
                                                <select className="form-select" onChange={(e) => HandleReportAtt(e.target.value)}>
                                                    <option value='1'>Individual Employee Reports</option>
                                                    <option value='2'>All Employee Reports</option>
                                                    <option value='3'>Custom Reports</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-md-3 mb25' style={{ display: att_report_status == 1 ? 'block' : 'none' }}>
                                        <div className='form-blk'>
                                            <div className='form-label'>Employee</div>
                                            <div className='form-input'>
                                                <select style={{ borderColor: erremp ? erremp : '' }} className="form-select" value={emp} onChange={e => setEmp(e.target.value)} >
                                                    <option value="">Select Employee</option>
                                                    {
                                                        emplist?.map((item, ind) => {
                                                            return <option key={ind} value={item.id}>{item.name}</option>
                                                        })
                                                    }
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='col-md-3 mb25' style={{ display: att_report_status == 2 ? 'block' : 'none' }}>
                                        <div className='form-blk'>
                                            <div className='form-label'>Company</div>
                                            <div className='form-input'>
                                                <select style={{ borderColor: errcompany ? errcompany : '' }} className="form-select" value={company} onChange={e => setCompany(e.target.value)}>
                                                    <option value=''>Select Company</option>
                                                    {
                                                        comdata?.map((item, ind) => (
                                                            <option key={ind} value={item.id}>{item.name}</option>
                                                        ))}
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-md-3 mb25' style={{ display: att_report_status == 2 ? 'block' : 'none' }}>
                                        <div className='form-blk'>
                                            <div className='form-label'>Department</div>
                                            <div className='form-input'>
                                                <select style={{ borderColor: errdepartment ? errdepartment : '' }} className="form-select" value={department} onChange={e => setDepartment(e.target.value)}>
                                                    <option value=''>Select Division </option>
                                                    {
                                                        depdata?.map((item, ind) => (
                                                            <option key={ind} value={item.id}>{item.name}</option>
                                                        ))}
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-md-3 mb25' style={{ display: att_report_status == 1 ? 'block' : 'none' }}>
                                        <div className='form-blk'>
                                            <div className='form-label'>Report Type</div>
                                            <div className='form-input'>
                                                <select style={{ borderColor: errduration ? errduration : '' }} className="form-select" value={duration} onChange={e => setDuration(e.target.value)}>
                                                    <option value=''>Select Duration</option>
                                                    <option value='1'>Monthly</option>
                                                    <option value='2'>Yearly</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-md-3 mb25' style={{ display: att_report_status == 3 ? 'block' : 'none' }}>
                                        <div className='form-blk'>
                                            <div className='form-label'>From Date</div>
                                            <div className='form-input'>
                                                <input onChange={e => setFromdate(e.target.value)} type="date" className="form-control" value={fromdate} placeholder="Select From Date" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-md-3 mb25' style={{ display: att_report_status == 3 ? 'block' : 'none' }}>
                                        <div className='form-blk'>
                                            <div className='form-label'>To Date</div>
                                            <div className='form-input'>
                                                <input type="date" onChange={e => setTodate(e.target.value)} className="form-control" value={todate} placeholder="Select To Date" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-md-3 mb25'>
                                        <div className='form-blk'>
                                            <label className="h22"></label>
                                            <div className='form-input'>
                                                <button className="btn_5"
                                                    onClick={HandleClick_DownloadExc_CustomReport}
                                                >Download</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div> */}


                            {/* <div className="tab-pane" style={{ display: 'block' }}>
                                <div className='row'>
                                    <div className='col-md-3'>
                                        <div className='form-blk mb25'>
                                            <div className='form-label'>Report {reportCat}</div>
                                            <div className='form-input'>
                                                <select onChange={e => setReportCat(e.target.value)} value={reportCat} className="form-select">
                                                    <option value=''>Select Division </option>
                                                    <option value='1'>Division</option>
                                                    <option value='2'>Department</option>
                                                    <option value='3'>Employee</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div> */}



                            <div className="tab-pane" style={{ display: reportCat == 1 ? 'block' : 'none' }}>
                                <div className='row' >
                                    <div className='col-md-3'>
                                        <div className='form-blk mb25'>
                                            <div className='form-label'>Division</div>
                                            <div className='form-input'>
                                                <select onChange={e => handleChange(e.target.value)} value={deptid} className="form-select">
                                                    <option value=''>Select Division </option>
                                                    <option value='DIVISION-All'>ALL Division </option>
                                                    {
                                                        dept?.map((item, ind) => {
                                                            return <option key={ind + 1} value={item.id}>{item.name}</option>
                                                        })
                                                    }
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <div className='col-md-3'>
                                        <div className='form-blk mb25'>
                                            <div className='form-label'>Department</div>
                                            <div className='form-input'>
                                                <select value={skill} className="form-select" onChange={e => { handleChangeGetDept(e.target.value) }}>
                                                    <option value=''>Select Department </option>
                                                    {
                                                        skillsList.map((item, ind) => {
                                                            return <option value={item.id}>{item.name}</option>
                                                        })
                                                    }
                                                </select>
                                            </div>
                                        </div>
                                    </div> */}
                                    {/* <div className='col-md-3'>
                                        <div className='form-blk mb25'>
                                            <div className='form-label'>Employee</div>
                                            <div className='form-input'>
                                                <select value={empid} className="form-select"
                                                    onChange={e => { setEmpid(e.target.value) }}
                                                >
                                                    <option value=''>Select Employee </option>
                                                    {
                                                        filteredEmp?.map((item, ind) => {
                                                            return <option value={item.id}>{item.name}</option>
                                                        })
                                                    }
                                                </select>
                                            </div>
                                        </div>
                                    </div> */}
                                    {/* <div className='col-md-3'>
                                        <div className='form-blk mb25'>
                                            <div className='form-label'>Report</div>
                                            <div className='form-input'>
                                                <select value={reporttype} onChange={e => setReporttype(e.target.value)} className="form-select" >
                                                    <option value=''>Select Report </option>
                                                    <option value='1'>Current Week </option>
                                                    <option value='2'>Current Month </option>
                                                    <option value='3'>Current Year </option>
                                                    <option value='4'>Custom </option>

                                                </select>
                                            </div>
                                        </div>
                                    </div> */}

                                    <div className='col-md-3 mb25'>
                                        <div className='form-blk'>
                                            <div className='form-label'>From Date</div>
                                            <div className='form-input'>
                                                <input onChange={e => setFromdatedivision(e.target.value)} type="date" className="form-control" value={fromdatedivision} placeholder="Select From Date" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-md-3 mb25'>
                                        <div className='form-blk'>
                                            <div className='form-label'>To Date</div>
                                            <div className='form-input'>
                                                <input type="date" onChange={e => setTodatedivision(e.target.value)} className="form-control" value={todatedivision} placeholder="Select To Date" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-md-3 mb25'>
                                        <div className='form-blk'>
                                            <label className="h22"></label>
                                            <div className='form-input'>
                                                <button className="btn_5"
                                                    onClick={HandleClick_EMP_DIV_Report}
                                                >Download</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="tab-pane" style={{ display: reportCat == 2 ? 'block' : 'none' }}>
                                <div className='row' >
                                    <div className='col-md-3'>
                                        <div className='form-blk mb25'>
                                            <div className='form-label'>Division</div>
                                            <div className='form-input'>
                                                <select onChange={e => handleChange(e.target.value)} value={deptid} className="form-select">
                                                    <option value=''>Select Division </option>
                                                    {
                                                        dept?.map((item, ind) => {
                                                            return <option key={ind + 1} value={item.id}>{item.name}</option>
                                                        })
                                                    }
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-md-3'>
                                        <div className='form-blk mb25'>
                                            <div className='form-label'>Department</div>
                                            <div className='form-input'>
                                                <select value={skill} className="form-select" onChange={e => { handleChangeGetDept(e.target.value) }}>
                                                    <option value=''>Select Department </option>
                                                    {
                                                        skillsList.map((item, ind) => {
                                                            return <option value={item.id}>{item.name}</option>
                                                        })
                                                    }
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-md-3 mb25'>
                                        <div className='form-blk'>
                                            <div className='form-label'>From Date</div>
                                            <div className='form-input'>
                                                <input onChange={e => setFromdatedivision(e.target.value)} type="date" className="form-control" value={fromdatedivision} placeholder="Select From Date" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-md-3 mb25'>
                                        <div className='form-blk'>
                                            <div className='form-label'>To Date</div>
                                            <div className='form-input'>
                                                <input type="date" onChange={e => setTodatedivision(e.target.value)} className="form-control" value={todatedivision} placeholder="Select To Date" />
                                            </div>
                                        </div>
                                    </div>

                                    <div className='col-md-3 mb25'>
                                        <div className='form-blk'>
                                            <label className="h22"></label>
                                            <div className='form-input'>
                                                <button className="btn_5"
                                                    onClick={HandleClick_EMP_DIV_Report}
                                                >Download</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div >
        </>
    )
}

export default UserReportsComp
